<!--
 * @Author: mzw
 * @Date: 2025-04-21 09:15:08
 * @LastEditTime: 2025-04-21 09:15:08
 * @LastEditors: mzw
 * @Description: 物料助手-批任务模式
-->
<template>
  <div class="common-layout cf ac jc">
    <!-- 物料助手-模式切换（absolute） -->
    <div class="mode-selector">
      <el-select
        v-model="modeType"
        placeholder="请选择模式"
        style="width: 218px"
        @change="selectMode"
      >
        <el-option
          v-for="(item,index) in modeOpt"
          :key="index"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </div>
    <div class="page-title">
      <img src="~@/assets/img/AI/material_title.png" />
    </div>
    <!-- 文件上传 -->
    <div class="upload-page rf ac jsb" v-if="!isAnalyzing">
      <div class="chunk-box rf ac jc">
        <div class="scan-box">
          <img src="~@/assets/img/AI/material_scan_bg.png" />
          <img src="~@/assets/img/AI/material_scan_act.png" />
          <div class="progress-bar rf ac jc" v-if="isShowProgress">
            <ul>
              <li
                v-for="(item, index) in progressList"
                :key="index"
                class="cf ac"
                :class="{ active: item.value== progressActive}"
              >
                <div class="bar-dot"></div>
                {{item.label}}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="chunk-box1 rf ac jc">
        <div class="upload-box cf">
          <el-upload
            class="flex-1 cf"
            ref="uploadRef"
            drag
            action="/api/help/fileupload/sys/upload"
            multiple
            accept=".xlsx, .xls"
            :limit="1"
            :on-exceed="handleExceed"
            :on-success="handleUploadSuccess"
            :before-upload="beforeUpload"
          >
            <div class="upload-inner cf ac jc">
              <!-- <el-icon class="el-icon--upload"><upload-filled /></el-icon> -->
              <img src="~@/assets/img/AI/material_upload_icon.png" />
              <div class="el-upload__text">
                点击或将文件拖拽到这里上传
              </div>
              <div class="el-upload__tip">
                支持上传10M(1000行)以内的xls\xlsx文件
              </div>
            </div>
          </el-upload>

          <el-form ref="form">
            <el-form-item label="规范物料表述：">
              <el-tooltip
                content="选择是会对物料描述进行智能拆解并且重新规范化，但是任务执行耗时较长。"
                placement="top"
              >
                <el-switch
                  v-model="standardMaterial"
                  inline-prompt
                  active-text="是"
                  inactive-text="否"
                />
              </el-tooltip>
            </el-form-item>
          </el-form>
          <div class="handle-box rf ac jc">
            <div
              class="btn-box rf ac jc"
              @click="toMyMaterials"
              v-if="hasMyMaterials"
            >
              历史记录
            </div>
            <div
              class="btn-box btn-solid rf ac jc"
              @click="submitTask"
            >
              确认上传
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 文件解析ing -->
    <div class="analyzing-box" v-if="isAnalyzing">
      <div class="progress-bar">
        <div class="bar-box">
          <!-- 注：还需要加进度条动画 -->
          <div class="bar" style="width: 0%" ref="analyzingBar"></div>
        </div>
        <ul class="rf ac jsb">
          <li
            v-for="(item, index) in progressList"
            :key="index"
            class="cf ac"
            :class="{ done: item.value<analyzeActive, current: item.value== analyzeActive}"
          >
            <div class="node-dot rf ac jc">
              <!-- 已完成 -->
              <i
                v-if="item.value<analyzeActive"
                class="el-icon-check">
              </i>
              <!-- 当前 -->
              <i
                v-else-if="item.value== analyzeActive"
                class="el-icon-more">
              </i>
              <!-- 未完成 -->
              <template v-else>
                {{index+1}}
              </template>
            </div>
            <span class="node-txt">
              {{item.label}}
            </span>
          </li>
        </ul>
      </div>
      <div class="warn-box rf ac jc">
        <p class="warn">
          处理中，请勿关闭页面，稍事等待...
        </p>
      </div>
    </div>
    <div class="introduce-box">
      <img src="~@/assets/img/AI/material_blurb1.png" />
      <img src="~@/assets/img/AI/material_blurb2.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'materialAssistantBatch',
  data () {
    return {
      progressList: [
        { label: '上传文件', value: 1},
        { label: '智能解析文件', value: 2},
        { label: '物料描述规范化', value: 3},
        { label: '智能分析诊断匹配', value: 4},
        { label: '输出结果', value: 5}
      ],
      progressActive: 0,
      isShowProgress: false,
      // 描点
      timer0: null,
      timer1: null,
      // 文件上传
      fileObj: null,
      // 文件上传后提交
      standardMaterial: false,
      taskId: '',
      // 文件解析
      isAnalyzing: false,
      // 定时查询文件解析进度
      timer2: null,
      analyzeActive: 0,
      barPercent: 0,
      // 模式切换
      modeOpt: [
        { label: '对话模式', value: 1 },
        { label: '批任务模式', value: 2 },
      ],
      modeType: 2,
      // 历史记录
      hasMyMaterials: false
    }
  },
  mounted () {
    this.startProgress();
    this.queryMyMaterials();
  },
  destroyed() {
    if(this.timer0) {
      clearTimeout(this.timer0);
    }
    if(this.timer1) {
      clearInterval(this.timer1);
    }
    if(this.timer2) {
      clearInterval(this.timer2);
    }
  },
  methods: {
    // 描点
    progressRoute () {
      this.timer1 = setInterval(() => { //超时关闭loading
        this.progressActive +=1;
        if(this.progressActive===6) {
          this.progressActive =0;
          this.isShowProgress = false;
          clearInterval(this.timer1);
          // 开始下一轮
          this.startProgress();
        }
      }, 430)
    },
    startProgress() {
      this.timer0 = setTimeout(()=>{
        this.isShowProgress = true;
        clearTimeout(this.timer0);
        // 开始描点动效
        this.progressRoute();
      }, 2500)
    },

    // 文件上传
    beforeUpload(file) {
      const testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = ['xls', 'XLS', 'xlsx', 'XLSX'].includes(testmsg)
      const isLt10M = file.size / 1024 / 1024 <= 10
      if (!extension) {
        this.$message.warning('只能上传 xls、xlsx 格式!')
      }
      if (!isLt10M) {
        this.$message.warning('图片大小不得超过10MB!')
      }
      return extension && isLt10M
    },
    handleUploadSuccess(e, file) {
      this.fileObj= file.response.data;
    },
    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 ${this.$refs.uploadRef.limit || 1} 个文件,请删除后再次上传`);
    },

    // 文件上传后提交
    submitTask() {
      if(!this.fileObj || !this.fileObj.url) {
        this.$message.warning("请先上传文件");
        return false;
      } 
      const params = {
        fileUrl: this.fileObj.url,
        standardMaterial: this.standardMaterial,
        sourceType: 2 //来源类型 1:AI数字平台 2：官网平台 3：H5移动端
      }
      this.$http
        .post(`/help/ai/user/materialAssistant/submitTask`, params)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.taskId = res.data
          // 展示文件解析进度
          this.isAnalyzing = true
          this.analyzeRoute()
        })
    },

    // 文件解析
    analyzeRoute() {
      this.timer2 = setInterval(() => {
        this.getAnalyzeStep()
      }, 1000)
    },
    getAnalyzeStep() {
      this.$http
        .get(`/help/ai/user/materialAssistant/info`, {
          taskId: this.taskId
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.setAnalyzeStep(res.data.executionStep);
        })
    },
    setAnalyzeStep(executionStep) {
      // 接口-执行步骤-executionStep：1解析原文件 2描述规范输出 3智能分析诊断匹配 4完成
      // 对应的analyzeActive值需要+1
      this.analyzeActive = Number(executionStep) +1;

      // 设置解析进度条width
      if(this.analyzeActive==2) {
        this.barPercent = 25
      } else if(this.analyzeActive==3) {
        this.barPercent = 50
      } else if(this.analyzeActive==4) {
        this.barPercent = 75
      } else if(this.analyzeActive==5) {
        this.barPercent = 100
      }
      this.$nextTick(()=>{
        this.$refs.analyzingBar.style.width = this.barPercent + '%';
      })

      // 已完成处理
      if(this.analyzeActive === 5) {
        // 已完成则结束定时请求接口
        clearInterval(this.timer2);
        // 跳到列表页
        this.$router.push({
          name: 'materialAssistantList'
        })
      }
    },

    // 模式切换
    selectMode(val) {
      if(val==1) {
        this.$router.push({
          name: 'chatHome'
        })
      }
    },

    // 历史记录
    queryMyMaterials () {
      // 查询当前用户是否有记录
      this.$http
        .post(`/help/ai/user/materialAssistant/detail/listByPage`, {
          createUserId: this.$store.state.user.userId
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          if(res.data.dataList && res.data.dataList.length>0) {
            this.hasMyMaterials = true
          }
        })
    },
    toMyMaterials() {
      this.$router.push({
        name: 'materialAssistantList'
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.common-layout {
  width: 100%;
  position: relative;
  // background: url("/@/assets/chat/material_analyzing_bg.png") center no-repeat;
  // background-size: cover;
  background: url("~@/assets/img/AI/pageBg.png") no-repeat center rgb(236,244,254);
}

.mode-selector {
  position: absolute;
  left: 25px;
  top: 25px;
  ::v-deep .el-select {
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.5);
    border: 1px solid #FFFFFF;
    // 选择框及图标样式
    .el-input__inner,
    .el-icon {
      font-size: 16px !important;
      color: #333 !important;
    }
    .el-input__inner{
      border: none;
      background-color: transparent;
    }
  }
  &.small-state {
    left: 5px;
    ::v-deep .el-select {
      .el-input__inner,
      .el-icon {
        font-size: 14px !important;
      }
    }
  }
}

.page-title {
  margin-top: 40px;
}

.upload-page {
  width: 990px;
  margin: 20px 0 45px 0;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid #FFFFFF;
  border-radius: 8px;
  .chunk-box,
  .chunk-box1 {
    height: 375px;
    // background: #fff;
    // border-radius: 8px;
  }
  .chunk-box {
    width: 500px;
    .scan-box {
      width: 410px;
      margin: 0 auto;
      height: 260px;
      border-radius: 8px;
      overflow: hidden;
      position: relative;
      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
      .progress-bar {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        ul {
          width: 274px;
          height: 154px;
          position: relative;
          background: url("~@/assets/img/AI/material_scan_route.png") center no-repeat;
          li {
            position: absolute;
            font-size: 12px;
            color: #fff;
            width: 100px;
            .bar-dot {
              width: 10px;
              height: 10px;
              border-radius: 5px;
              background: #fff;
              border: 1px solid rgba(41, 226, 143, 0.4);
              box-sizing: border-box;
            }
            &.active .bar-dot {
              background: #29E28F;
              border-color: #fff;
            }
          }
          li:nth-child(1) {
            left: -20px;
            top: -3px;
          }
          li:nth-child(2) {
            left: 50%;
            top: -3px;
          }
          li:nth-child(3) {
            right: -48px;
            top: 50%;
            transform: translateY(-50%);
          }
          li:nth-child(4) {
            left: 50%;
            bottom: -19px;
          }
          li:nth-child(5) {
            left: -20px;
            bottom: -19px;
          }
        }
      }
    }
  }
  .chunk-box1 {
    // width: 540px;
    flex: 1;
    // margin-left: 20px;
    background: rgba(255, 255, 255, 0.5);
    .upload-box {
      width: 100%;
      padding: 0 15px;
      height: 343px;
      overflow: hidden;
      ::v-deep .el-upload {
        // height: 100% !important;
        flex: 1;
        .el-upload-dragger {
          height: 100% !important;
          width: 100% !important;
        }
        .upload-inner {
          height: 100%;
        }
      }
      .el-upload__text {
        font-size: 18px;
        color: #000;
        margin: 15px 0 5px 0;
      }
      .el-upload__tip {
        font-size: 12px;
        color: #969899;
      }

      .file-box {
        border: 1px dashed var(--el-border-color);
        border-radius: 6px;
        position: relative;
        .close-btn {
          position: absolute;
          right: 0;
          top: 0;
          display: none;
        }
        &:hover {
          .close-btn {
            display: block;
          }
        }
        &> img {
          width: 60px;
          height: 60px;
        }
        &> span {
          font-size: 14px;
          text-align: center;
          margin-top: 10px;
        }
      }
    }

    ::v-deep .el-form-item {
      margin-bottom: 0 !important;
    }

    .handle-box {
      width: 100%;
      .btn-box {
        width: 136px;
        height: 43px;
        font-size: 14px;
        color: #365FD8;
        border-radius: 8px;
        border: 1px solid rgba(54, 95, 216, 0.4);
        margin: 0 5px;
        cursor: pointer;
        &.btn-solid {
          color: #fff;
          background: var(--color-primary);
          box-shadow: var(--gradient-BoxShadow);
        }
      }
    }
  }
}

.analyzing-box {
  width: 1060px;
  max-width: 95%;
  height: 375px;
  background: #fff;
  border-radius: 8px;
  margin: 20px 0 45px 0;
  background: rgba(255, 255, 255, 0.5);
  .progress-bar {
    margin: 117px auto;
    width: 830px;
    position: relative;
    .bar-box {
      position: absolute;
      top: 14px;
      margin: 0 25px;
      width: calc(100% - 50px);
      .bar {
        // width: 25%;
        height: 4px;
        background: linear-gradient(271deg, #2A54D1 0%, #5B85FF 100%);
        transition: width 1s ease-in-out; /* 动画效果 */
      }
    }
    ul {
      position: relative;
      z-index: 10;
      li {
        .node-dot {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: rgb(212, 212, 212);
          border: 2px solid rgba(255, 255, 255, 0.5);
          box-shadow: 0px 1px 4px 0px rgba(153, 153, 153, 0.5);
          box-sizing: border-box;
          font-size: 16px;
          color: #fff;
        }
        &.done .node-dot {
          background: linear-gradient(315deg, #00CE72 0%, #29E28F 100%);
          border: 2px solid rgba(255, 255, 255, 0.4);
          box-shadow: 0px 1px 4px 0px rgba(41, 226, 143, 0.5);
        }
        &.current .node-dot {
          background: linear-gradient(315deg, #2A54D1 0%, #5B85FF 100%);
          border: 2px solid rgba(255, 255, 255, 0.5);
          box-shadow: 0px 1px 4px 0px rgba(42, 84, 209, 0.5);
        }
        .node-txt {
          font-size: 14px;
          color: #333333;
          margin-top: 12px;
        }
      }
    }
  }
  .warn-box {
    width: 100%;
    height: 76px;
    background: rgba(255, 255, 255, 0.5);
    .warn {
      width: 341px;
      height: 43px;
      line-height: 43px;
      font-size: 14px;
      color: #525A73;
      text-align: center;
      background: rgba(184, 219, 255, 0.1);
      border: 1px solid #FFFFFF;
    }
  }
}
.introduce-box {
  width: 1200px;
  img {
    margin-bottom: 30px;
  }
}
</style>